import React, { useState } from "react";
import { styled } from "styled-components";
import axios from "axios";
import { LoaderSpinner } from "./LoaderSpinner";

const ModalBackground = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContainer = styled.div`
    width: 420px;
    max-width: 95%;
    padding: 20px;
    background-color: white;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

    display: flex;
    flex-direction: column;
    gap: 16px;

    animation: fadeIn 0.2s ease;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: scale(0.95);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }
`;

const Title = styled.h3`
    font-size: 18px;
    font-weight: 600;
    text-align: left;
`;

const Description = styled.p`
    font-size: 14px;
    color: #4b5563;
    text-align: left;
    line-height: 1.4;
`;

const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const CancelBtn = styled.button`
    background-color: white;
    color: black;
    font-weight: 500;
    border-radius: 6px;
    font-size: 15px;
    border: 1px solid #d1d5db;
    cursor: pointer;
    padding: 8px 16px;
    &:hover {
        background-color: #f3f4f6;
    }
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const DeleteBtn = styled.button`
    background-color: #dc2626;
    color: white;
    font-weight: 500;
    border-radius: 6px;
    font-size: 15px;
    border: none;
    cursor: pointer;
    padding: 8px 16px;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    &:hover {
        background-color: #b91c1c;
    }
    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export default function AlertModal({
    openModal,
    setOpenModal,
    documentName = "",
    bucketId = "",
    org = "",
    onSuccess, // callback after successful deletion
}) {
    const [loading, setLoading] = React.useState(false);

    const handleCloseModal = () => {
        if (loading) return;
        setOpenModal(false);
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            await axios.delete("https://stg-bex.coolriots.ai/feo-v3/api/files", {
                data: {
                    fileKey: documentName,
                    bucketId: bucketId,
                    org: org,
                },
            });

            if (onSuccess) onSuccess(documentName); // callback to refresh list
            setOpenModal(false);
        } catch (error) {
            console.error("Delete failed:", error);
            alert("Failed to delete document. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {openModal && (
                <ModalBackground onClick={handleCloseModal}>
                    <ModalContainer onClick={(e) => e.stopPropagation()}>
                        <Title>Delete Document</Title>
                        <Description>
                            Are you sure you want to delete{" "}
                            <strong>{documentName}</strong>? This action cannot be undone.
                        </Description>

                        <Footer>
                            <CancelBtn onClick={handleCloseModal} disabled={loading}>
                                Cancel
                            </CancelBtn>
                            <DeleteBtn onClick={handleDelete} disabled={loading}>
                                {loading && <LoaderSpinner size={16} />}
                                {loading ? "Deleting..." : "Delete"}
                            </DeleteBtn>
                        </Footer>
                    </ModalContainer>
                </ModalBackground>
            )}
        </>
    );
}
